var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (columns, undefined) {
// iterate columns
;(function(){
  var $$obj = columns;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var column = $$obj[$index];

buf.push("<div class=\"exhibitors-column\">");
// iterate column
;(function(){
  var $$obj = column;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

if ( item.get('partner') && item.get('partner').name)
{
buf.push("<div class=\"exhibitor-item\"><span class=\"mlsb-suggestion-thumbnail\"><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + "><span class=\"mlsb-suggestion-fallback\">");
if ( item.artworks().length > 0)
{
buf.push("<img" + (jade.attr("src", item.artworks().models[0].defaultImageUrl('square'), true, true)) + ">");
}
buf.push("</span></a></span><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + " class=\"exhibitor-name\">" + (jade.escape(null == (jade_interp = item.get('partner').name) ? "" : jade_interp)) + "</a>");
if ( item.get('partner').artworks_count > 0)
{
buf.push("<button" + (jade.attr("data-id", item.get('partner').default_profile_id, true, true)) + " class=\"avant-garde-follow-button-black follow-button is-small\"></button>");
}
buf.push("</div>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

if ( item.get('partner') && item.get('partner').name)
{
buf.push("<div class=\"exhibitor-item\"><span class=\"mlsb-suggestion-thumbnail\"><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + "><span class=\"mlsb-suggestion-fallback\">");
if ( item.artworks().length > 0)
{
buf.push("<img" + (jade.attr("src", item.artworks().models[0].defaultImageUrl('square'), true, true)) + ">");
}
buf.push("</span></a></span><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + " class=\"exhibitor-name\">" + (jade.escape(null == (jade_interp = item.get('partner').name) ? "" : jade_interp)) + "</a>");
if ( item.get('partner').artworks_count > 0)
{
buf.push("<button" + (jade.attr("data-id", item.get('partner').default_profile_id, true, true)) + " class=\"avant-garde-follow-button-black follow-button is-small\"></button>");
}
buf.push("</div>");
}
    }

  }
}).call(this);

buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var column = $$obj[$index];

buf.push("<div class=\"exhibitors-column\">");
// iterate column
;(function(){
  var $$obj = column;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

if ( item.get('partner') && item.get('partner').name)
{
buf.push("<div class=\"exhibitor-item\"><span class=\"mlsb-suggestion-thumbnail\"><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + "><span class=\"mlsb-suggestion-fallback\">");
if ( item.artworks().length > 0)
{
buf.push("<img" + (jade.attr("src", item.artworks().models[0].defaultImageUrl('square'), true, true)) + ">");
}
buf.push("</span></a></span><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + " class=\"exhibitor-name\">" + (jade.escape(null == (jade_interp = item.get('partner').name) ? "" : jade_interp)) + "</a>");
if ( item.get('partner').artworks_count > 0)
{
buf.push("<button" + (jade.attr("data-id", item.get('partner').default_profile_id, true, true)) + " class=\"avant-garde-follow-button-black follow-button is-small\"></button>");
}
buf.push("</div>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

if ( item.get('partner') && item.get('partner').name)
{
buf.push("<div class=\"exhibitor-item\"><span class=\"mlsb-suggestion-thumbnail\"><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + "><span class=\"mlsb-suggestion-fallback\">");
if ( item.artworks().length > 0)
{
buf.push("<img" + (jade.attr("src", item.artworks().models[0].defaultImageUrl('square'), true, true)) + ">");
}
buf.push("</span></a></span><a" + (jade.attr("href", "/show/" + item.get('id'), true, true)) + " class=\"exhibitor-name\">" + (jade.escape(null == (jade_interp = item.get('partner').name) ? "" : jade_interp)) + "</a>");
if ( item.get('partner').artworks_count > 0)
{
buf.push("<button" + (jade.attr("data-id", item.get('partner').default_profile_id, true, true)) + " class=\"avant-garde-follow-button-black follow-button is-small\"></button>");
}
buf.push("</div>");
}
    }

  }
}).call(this);

buf.push("</div>");
    }

  }
}).call(this);
}.call(this,"columns" in locals_for_with?locals_for_with.columns:typeof columns!=="undefined"?columns:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;